// removed by extract-text-webpack-plugin
module.exports = {"ScreenXSMax":"(max-width: 767px)","ScreenSMMax":"(max-width: 991px)","Margin":"0.5rem","listWrapper":"Ga1ba26","listItem":"G958ce0"};